import { KYMW0A00Model } from '../kymw0a00.model';
import { MembersVoiceSearchModel } from '../vo/members-voice-search.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声一覧を取得するサービス
 *
 * @export GetMembersVoicePcodeListService
 * @class GetMembersVoicePcodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMembersVoicePcodeListService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private vo: MembersVoiceSearchModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMembersVoicePcodeListService
   */
  private getBody(): PlessRequest {
    // Ｐコード
    const pcodeList: Array<string> = this.vo.setPcode;
    const nvalInputList: Array<any> = this.vo.nvalInputList;
    const orderGoodsFlgInput: Array<any> = this.vo.orderGoodsFlgKoma;
    return new PlessRequest({
      search: {
        GetMembersVoicePcodeList: {
          condition: {
            CoopCode: this.vo.setCoopCode,
            OrderCode: this.vo.setOrderCode,
            SortItem: this.vo.sortItem,
            SortOrder: this.vo.sortOrder,
            PageNum: this.vo.pageNum,
            InitFlg: this.vo.initFlg,
            OrderGoodsFlg: this.vo.orderGoodsFlg,
            FormId: this.vo.formId
          },
          combination: pcodeList.map((x, i) => {
            return {
              condition: {
                Pcode: pcodeList[i],
                ReceiptSOrderCode: nvalInputList[i].receiptSOrderCode,
                ItemCode: nvalInputList[i].itemCode,
                OrderNum6Digits: nvalInputList[i].orderNum6Digits,
                pCode: orderGoodsFlgInput[i].PCode,
                OrderGoodsFlg: orderGoodsFlgInput[i].OrderGoodsFlg
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof GetMembersVoicePcodeListService
   */
  execute(model: KYMW0A00Model, vo: MembersVoiceSearchModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getMembersVoicePcodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMembersVoicePcodeListService
   */
  success(data: any): void {
    // サーバからの結果を元に、組合員の声一覧データを更新する
    this.model.getMembersVoicePcodeList(data);
    // 後続処理を実行
    this.successFunc();
  }
}
